import { useEffect } from "react";
import { LanguageProvider } from "./context/languageContext";
// Default V2 theme
import "survey-core/defaultV2.min.css";
import { StylesManager } from "survey-core";
import "./main-styles.css";

// components
import { DialogBox } from "./components/DialogBox/DialogBox";
import Header from "./components/Header/Header";
import { Screens } from "./screens/Screens";

// helper functions
import {
  limitedPageRefresh,
  newDayClearRefreshed,
} from "./Helper_functions/Helper_functions";
import { checkAndUpdateSurveys,checkAndUpdateSurveyKeys, checkAndUpdatePrivacyForm } from "./Helper_functions/databaseService/databaseService";
import { LanguageIdProvider } from "./context/languageIdContext";

StylesManager.applyTheme("defaultV2");

function App() {
  useEffect(() => {
    newDayClearRefreshed();
    if (
      JSON.parse(window.localStorage.getItem("swUpdateReady") || "false") ==
      true
    ) {
      console.log("swUpdateReady");
      window.localStorage.setItem("swUpdateReady", JSON.stringify(false));
      window.stop();
      limitedPageRefresh();
      console.log("reload");
    }

    // check for new surveys
    checkAndUpdateSurveys();
    checkAndUpdateSurveyKeys();
    checkAndUpdatePrivacyForm();
  }, []);

  return (
    // use context
    <LanguageIdProvider>
        <div className="app-container">
      
          <Header />
          <Screens />
          <DialogBox />
        </div>
    </LanguageIdProvider>
  );
}
export default App;
